/*
 *
 * Classes actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_CLASSES,
  LOAD_CLASSES_SUCCESS,
  LOAD_CLASSES_ERROR,
  UPDATE_CLASS,
  UPDATE_CLASS_SUCCESS,
  UPDATE_CLASS_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the classes, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_CLASSES
 */
export function loadClasses() {
  return {
    type: LOAD_CLASSES,
  };
}

/**
 * Dispatched when the loadClasses are loaded by the request saga
 *
 * @param  {array} variables true for classes
 *
 * @return {object} An action object with a type of LOAD_CLASSES_SUCCESS passing the variables
 */
export function loadClassesSuccess(itemsList, firstElem) {
  return {
    type: LOAD_CLASSES_SUCCESS,
    itemsList,
    firstElem
  };
}

/**
 * Dispatched when loading the loadClasses fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_CLASSES_ERROR passing the error
 */
export function loadClassesError(error) {
  return {
    type: LOAD_CLASSES_ERROR,
    error,
  };
}

// Update for Single User
export function updateClass(classDetail) {
  return {
    type: UPDATE_CLASS,
    classDetail
  };
}
export function updateClassSuccess(classDetail) {
  return {
    type: UPDATE_CLASS_SUCCESS,
    classDetail,
  };
}

export function updateClassError(error) {
  return {
    type: UPDATE_CLASS_ERROR,
    error,
  };
}